import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";

export const ServicePackagesWrapper = styled.div.attrs(({bgColor}) => ({
    bgColor
}))`
    margin: 0 auto;
    display: flex;
    ${({bgColor}) =>
            bgColor &&
            css`
                background-color: ${({bgColor}) => bgColor};
            `}
`;

export const ServicePackagesInnerWrapper = styled.div.attrs(({bgColor}) => ({
    bgColor
}))`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    gap: 3rem;
    ${media.lessThan(breakpoints.ipad)`
        gap: 1.5rem;
  `}
`;

export const ServiceItemsWrapper = styled.div.attrs(({}) => ({}))`
    display: flex;
    justify-content: flex-start;
    row-gap: 3rem;
    column-gap: 2rem;
    flex-wrap: wrap;
    ${media.lessThan(breakpoints.ipad)`       
        row-gap: 1.5rem;   
  `}
`;